export class LesionType {
  private static _values: LesionType[] = [];
  private static _lookup: Map<number, LesionType> = new Map();

  static fromId(id: number) {
    const instance = LesionType._lookup.get(id);
    if (instance === undefined) {
      throw new Error('Not a valid LesionType.id: ' + id);
    }
    return instance;
  }

  static values(): LesionType[] {
    return [...LesionType._values];
  }

  // ---

  public readonly id: number;
  public readonly label: string;

  constructor(id: number, label: string) {
    this.id = id;
    this.label = label;
    LesionType._values.push(this);
    LesionType._lookup.set(id, this);
  }

  toJson(): { id: number; name: string } {
    return { id: this.id, name: this.label };
  }

  toString(): string {
    return '<LesionType: ' + this.id + ", label='" + this.label + "'>";
  }
}
